<template>
  <div class="main_box">
    <div class="main_bar" v-if="false">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <span class="currentSpan">投票人员分组</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <div></div>
    </div>
    <div class="main_body">
      <div class="form_bar">
        <div class="form_bar_search">
          <div class="condition_item"></div>
        </div>
        <div class="form_bar_btn">
          <el-button @click="goBackEditVote()" v-if="false">
            返回编辑投票
          </el-button>
          <el-button type="primary" @click="editUserGroup(null)">
            新增人员组
          </el-button>
        </div>
      </div>
      <el-table
        v-loading="tableLoading"
        :data="userGroupList"
        style="width: 100%"
      >
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="60"
        ></el-table-column>
        <el-table-column label="人员组名称">
          <template slot-scope="scope">
            <el-link
              type="primary"
              class="cell_link"
              @click.stop
              @click="userManager(scope.row.MeetingUserGroupID)"
            >
              {{ scope.row.MeetingUserGroupName }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column label="排序" width="50" align="center" key="Sort">
          <template slot-scope="scope">
            <span>{{ scope.row.Sort }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <el-link
              type="primary"
              class="cell_link"
              @click.stop
              @click="userManager(scope.row.MeetingUserGroupID)"
            >
              进入
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              @click.stop
              @click="editUserGroup(scope.row.MeetingUserGroupID)"
            >
              编辑
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              @click.stop
              @click="deleteUserGroup(scope.row)"
              v-if="scope.row.VoteNames.length === 0"
            >
              删除
            </el-link>
            <el-popover placement="left" width="400" trigger="hover">
              <el-table :data="scope.row.VoteNames">
                <el-table-column width="400" label="被以下投票使用">
                  <template slot-scope="scope1">
                    <span>{{ scope1.row }}</span>
                  </template></el-table-column
                >
              </el-table>
              <el-link
                title="被以下投票使用"
                type="primary"
                class="cell_link"
                slot="reference"
                v-if="scope.row.VoteNames.length !== 0"
                :disabled="scope.row.VoteNames.length !== 0"
              >
                删除
                <i class="el-icon-connection el-icon--right"></i>
              </el-link>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination_box">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="listQuery.MaxResultCount"
          :layout="pagination_layout"
          :total="listTotalCount"
        >
        </el-pagination>
      </div>
      <EditUserGroup
        :meetId="meetingId"
        :fatherSubmitDialog="editUserGroupDialog"
        ref="editUserGroup"
      ></EditUserGroup>
    </div>
  </div>
</template>
<script>
import voteUserApi from '../../../../api/vote/voteUser'
import EditUserGroup from '@/components/wj_user/EditUserGroup.vue'
export default {
  name: 'Home',
  components: {
    EditUserGroup
  },
  data () {
    return {
      meetingId: null,
      tableLoading: true,
      userGroupList: [],
      listTotalCount: 0,
      currentPage: 1,
      listQuery: {
        meetingId: null,
        maxResultCount: 10,
        skipCount: 0
      },
      pagination_layout: 'prev, pager, next'
    }
  },
  methods: {
    getVoteUserGroups: function () {
      this.tableLoading = true
      voteUserApi.getVoteUserGroups(this.listQuery).then(data => {
        this.userGroupList = data.Items
        this.listTotalCount = data.TotalCount
        this.tableLoading = false
      }).catch(err => {
        this.tableLoading = false
        return err
      })
    },
    indexMethod (index) {
      return this.listQuery.skipCount + index + 1
    },
    handleSizeChange (val) {
      this.listQuery.maxResultCount = val
      this.getVoteUserGroups()
    },
    handleCurrentChange (val) {
      this.listQuery.skipCount = (val - 1) * this.listQuery.maxResultCount
      this.getVoteUserGroups()
    },
    deleteUserGroup: function (item) {
      this.$confirm('确认删除人员组“' + item.MeetingUserGroupName + '”吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        const openLoading = this.openLoading('删除中…')
        voteUserApi.deleteVoteUserGroup({
          meetingUserGroupID: item.MeetingUserGroupID
        }).then(data => {
          openLoading.close()
          this.getVoteUserGroups()
          this.$message({
            type: 'success',
            message: '删除成功!',
            customClass: 'custom_message'
          })
        }).catch(err => {
          openLoading.close()
          return err
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
          customClass: 'custom_message'
        })
      })
    },
    editUserGroup: function (userGroupID) {
      this.$refs.editUserGroup.openEditUserGroup(userGroupID)
    },
    editUserGroupDialog: function () {
      this.getVoteUserGroups()
    },
    userManager: function (userGroupID) {
      this.$router.push({ name: 'wjUser', params: { mid: this.$route.params.mid, gid: userGroupID } })
    }
  },
  computed: {

  },
  created () {
    this.meetingId = this.$route.params.mid
    this.listQuery.meetingId = this.$route.params.mid
    this.getVoteUserGroups()
    if (this.is_xs) {
      this.pagination_layout = 'total,prev, pager, next'
    } else {
      this.pagination_layout = 'total, sizes, prev, pager, next, jumper'
    }
  }
}
</script>
